import { createStore } from 'vuex'
export default createStore({
  state: {
	  //取得token
	  tokenString: window.localStorage.getItem('GptMToken')?window.localStorage.getItem('GptMToken') : '',
	  uIdString: localStorage.getItem('userId') ? localStorage.getItem('userId') : '',
	  
  },
  mutations: {
	  // 修改token，并将token存入localStorage
	  changeLogin (state,token) {
	  	 state.tokenString = token.GptMToken;
	  	 window.localStorage.setItem('GptMToken', token.GptMToken);
	  },
	  
  },
  getters: {
	  tokenString(state) {
	  	return state.tokenString;
	  },
	  
	  uIdString(state) {
	  	return state.uIdString;
	  },
	 
  },
  actions: {
  },
  modules: {
  }
})





